import { investorApi } from '@core/api/httpClient'
import { ORDER_ENDPOINTS } from './orderEndpointPaths'
import { parsePlaceOrderResponse } from './orderParser'
import type {
  PlaceOrderPayloadDto,
  PlaceOrderResponseDto,
  OrderDetailResponseDto,
  OrderHistoryParams,
  OrderHistoryResponseDto,
  OrderHistoryFiltersResponseDto,
  CalculateFeesResponseDto,
} from './orderContracts'
import type { PlaceOrderInput, PlacedOrder } from '../types/orderTypes'

export async function placeOrder(input: PlaceOrderInput): Promise<PlacedOrder> {
  const payload: PlaceOrderPayloadDto = {
    offeringId: input.offeringId,
    tokenQuantity: input.tokenQuantity,
    idempotencyKey: input.idempotencyKey,
    acceptedTerms: input.acceptedTerms,
  }
  const { data } = await investorApi.post<PlaceOrderResponseDto>(ORDER_ENDPOINTS.ORDERS, payload)
  return parsePlaceOrderResponse(data)
}

export async function getOrderDetail(orderId: string): Promise<OrderDetailResponseDto> {
  const { data } = await investorApi.get<OrderDetailResponseDto>(
    ORDER_ENDPOINTS.ORDER_DETAIL.replace('{orderId}', orderId),
  )
  return data
}

export async function cancelOrder(orderId: string): Promise<void> {
  await investorApi.post(ORDER_ENDPOINTS.CANCEL_ORDER.replace('{orderId}', orderId))
}

export async function getOrderHistory(
  params: OrderHistoryParams,
): Promise<OrderHistoryResponseDto> {
  const { data } = await investorApi.get<OrderHistoryResponseDto>(ORDER_ENDPOINTS.ORDER_HISTORY, {
    params,
  })
  return data
}

export async function getOrderHistoryFilters(): Promise<OrderHistoryFiltersResponseDto> {
  const { data } = await investorApi.get<OrderHistoryFiltersResponseDto>(
    ORDER_ENDPOINTS.ORDER_HISTORY_FILTERS,
  )
  return data
}

export async function calculateFees(
  offeringId: string,
  tokenQuantity: number,
): Promise<CalculateFeesResponseDto> {
  const { data } = await investorApi.get<CalculateFeesResponseDto>(ORDER_ENDPOINTS.CALCULATE_FEES, {
    params: { offeringId, tokenQuantity },
  })
  return data
}
